/* Bone Fuel — shared chrome JS (ported from every page's inline script).
   Loaded once from layout/theme.liquid with `defer`. Page-specific behaviour
   (femur explorer, Supplement Facts renderer, PDP pickers, waitlist + apply
   form previews) lives inline in each section. */
(function () {
  /* nav: transparent at top, glass once scrolled past 40px.
     Harmless on the-science, whose nav is sticky+always-glass via CSS. */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* reveal-on-scroll. Pages without .reveal elements (the-science) no-op. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el, i) {
      el.style.transitionDelay = (i % 3 * 70) + 'ms';
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
})();
